import FontBody2 from "../../../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../../components/fonts/font-props";
import InstantExchangeStore from "../../../../../../stores/instant-exchange-store";
import useDashboardTranslation from "../../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import "./auth-period-in-days-field.scss";
import { observer } from "mobx-react";
import { IOption, SelectDropdown} from "../../../../../../components/inputs/select-dropdown/select-dropdown";
import { SingleValue } from "react-select";

interface Props {
    instantExchangeSetting?: InstantExchangeStore;
    pageScope: string;
    disabled?: boolean;
}

const AuthPeriodInDaysField: React.FC<Props> = observer(({instantExchangeSetting, pageScope, disabled}: Props) => {
    const { getTranslation } = useDashboardTranslation();
    const onAuthPeriodChange = (singleValue: SingleValue<IOption>) => {
        if (singleValue) {
            instantExchangeSetting?.setAuthPeriodInDays(singleValue.value as number)
        }
    }

    return (
        <div className="days-block">
            { instantExchangeSetting  &&
                <>
                    <SelectDropdown
                        disabled={disabled}
                        options={instantExchangeSetting?.authPeriodOptions}
                        onChange={o => onAuthPeriodChange(o)}
                        value={instantExchangeSetting?.authPeriodOptions.find(o => o.value === instantExchangeSetting?.authPeriodInDays)}
                    />
                    <FontBody2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}> {getTranslation('DAYS', pageScope)} </FontBody2>
                </>
            }
        </div>
    );
});

export default AuthPeriodInDaysField;